import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { CoreService } from 'app/services/entidades/core.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';

@Injectable()
export class AuthService extends CoreService {

  private endRef: Subscription;

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  /**
   * Autentifica a un usuario en el sistema
   * @param {JSON} user Datos del usuario a autentificar
   */
  signin(user) {
    return this.postMethod('auth/login', user);
  }

  /**
   * Crea un nuevo usuario
   * @param {JSON} user Datos del usuario en formato json
   */
  signup(user) {
    return this.postMethod('user/new', user);
  }

  /**
   * Crea el token en localStorage
   * @param {string} mail correo del usuario
   * @param {string} pass contraseña del usuario
   */
  saveToken(mail: string, pass: string, sistema: string) {
    let user = {
      "correo": mail,
      "clave": pass,
      "sistema": sistema,
      "gethash": "true"
    };
    this.endRef = this.signin(user).subscribe(
      res => {
        if (typeof res.status == 'undefined' || res.status == 'ok') {
          let token = res;
          try {
            localStorage.setItem('token', token);
            this.endRef.unsubscribe();
            return true;
          } catch (e) {
            console.error(e.message);
          }
        }
      },
      error => {
        console.error(error);
      });
  }

  /**
   * Retorna un objeto JSON con los datos del usuario activo
   */
  getUser() {
    let user = JSON.parse(localStorage.getItem('user'));
    try {
      if (user == null) {
        throw new Error('Debe crear el usuario en localStorage.');
      }
      return user;
    } catch (e) {
      return false;
    }
  }

  /**
   * Verifica la existencia de un sistema
   * @param  {string} nombre Nombre del sistema
   * @return {JSON}           Datos de la consulta
   */
  validaSistema(nombre: string): any {
    return this.getMethod(`auth/check/${nombre}`);
  }

  checkToken(token: string): Observable<any> {
    return this.getMethod(`auth/validar/token/${token}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/entidades/auth.service.ts